<section class="sav-wtu-hero" aria-label="Why trust SavingArena">
  <div class="sav-site-container">
    <app-breadcrumb [items]="crumbs" />
    <div class="sav-wtu-hero-inner">
      <span class="sav-wtu-eyebrow">Why Trust Us</span>
      <h1 class="sav-wtu-title">
        Why shoppers trust SavingArena <app-dev-flag note="Static hero copy" />
      </h1>
      <p class="sav-wtu-subtitle">
        Millions of shoppers rely on us for coupons that actually work. Here's what makes
        SavingArena a name you can trust — verified, secure and always on your side.
      </p>
    </div>
  </div>
</section>

<section class="sav-wtu-features-section" aria-label="Why trust SavingArena">
  <div class="sav-site-container">
    <div class="sav-wtu-section-head">
      <span class="sav-wtu-eyebrow">Our promise</span>
      <h2>
        Built on trust, honesty and real savings
        <app-dev-flag note="Static feature list (hardcoded array)" />
      </h2>
      <p>
        Every part of the SavingArena experience is designed around one goal — helping you save with
        total confidence.
      </p>
    </div>
    <div class="sav-wtu-features-grid">
      @for (feature of features; track feature.title) {
        <article class="sav-wtu-feature-card">
          <span class="sav-wtu-feature-icon" aria-hidden="true">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.4"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </span>
          <h3>{{ feature.title }}</h3>
          <p>{{ feature.description }}</p>
        </article>
      }
    </div>
  </div>
</section>

<section class="sav-wtu-steps-section" aria-label="How we verify coupons">
  <div class="sav-site-container">
    <div class="sav-wtu-section-head">
      <span class="sav-wtu-eyebrow">How we verify</span>
      <h2>
        Every coupon passes a six-step check
        <app-dev-flag note="Static verification steps (hardcoded array)" />
      </h2>
      <p>Before any offer reaches you, it goes through our verification process.</p>
    </div>
    <div class="sav-wtu-steps-grid">
      @for (step of steps; track step.title; let i = $index) {
        <article class="sav-wtu-step-card">
          <span class="sav-wtu-step-number">{{ (i + 1).toString().padStart(2, '0') }}</span>
          <h3>{{ step.title }}</h3>
          <p>{{ step.description }}</p>
        </article>
      }
    </div>
  </div>
</section>

<section class="sav-wtu-faq-section" aria-label="Frequently asked questions">
  <div class="sav-site-container">
    <div class="sav-wtu-section-head">
      <span class="sav-wtu-eyebrow">Good to know</span>
      <h2>Frequently asked questions <app-dev-flag note="Static FAQ block (hardcoded array)" /></h2>
      <p>What shoppers ask most about how we verify and list offers.</p>
    </div>
    <!-- Shared FAQ accordion (`.sav-faq-*` in styles.scss), so this page matches every other FAQ
         on the site. The "+" toggle is drawn by that CSS — no per-page icon span. -->
    <div class="sav-faq-list">
      @for (faq of faqs; track faq.question; let i = $index) {
        <div class="sav-faq-item" [class.expanded]="expandedFaq() === i">
          <button
            type="button"
            class="sav-faq-question"
            [attr.aria-expanded]="expandedFaq() === i"
            (click)="toggleFaq(i)"
          >
            {{ faq.question }}
          </button>
          <div class="sav-faq-answer" [class.visible]="expandedFaq() === i">
            <div class="sav-faq-answer-body">{{ faq.answer }}</div>
          </div>
        </div>
      }
    </div>
  </div>
</section>

<section class="sav-wtu-cta-section" aria-label="Contact us">
  <div class="sav-site-container">
    <div class="sav-wtu-cta-card">
      <h2>Still have a question?</h2>
      <p>Our team is here to help. Reach out and we'll get back to you within one business day.</p>
      <a class="sav-wtu-cta-button" routerLink="/contact-us">Contact Us</a>
    </div>
  </div>
</section>

<app-big-sale-banner />
